import React from "react";
import TimeCountDown from "../countdown";

const CampaignCountdown = (props) => {
  return (
    <section className="wpo-election-campaign-section section-padding">
      <div className="container">
        <div className="row justify-content-center">
          <div className="col col-lg-5 col-md-8 col-12">
            <div className="wpo-section-title">
              <div className="section-titl-shape-1">
                <svg width="687" height="473" viewBox="0 0 687 473" fill="none">
                  <g opacity="0.44" filter="url(#filter0_f_1_104)">
                    <circle cx="343.5" cy="129.5" r="129.5" />
                  </g>
                  <defs>
                    <filter
                      id="filter0_f_1_104"
                      x="0"
                      y="-214"
                      width="687"
                      height="687"
                      filterUnits="userSpaceOnUse"
                      colorInterpolationFilters="sRGB"
                    >
                      <feFlood floodOpacity="0" result="BackgroundImageFix" />
                      <feBlend
                        mode="normal"
                        in="SourceGraphic"
                        in2="BackgroundImageFix"
                        result="shape"
                      />
                      <feGaussianBlur
                        stdDeviation="107"
                        result="effect1_foregroundBlur_1_104"
                      />
                    </filter>
                  </defs>
                </svg>
              </div>
              <div className="section-titl-shape-2">
                <svg width="687" height="473" viewBox="0 0 687 473" fill="none">
                  <g opacity="0.44" filter="url(#filter0_f_1_105)">
                    <circle cx="343.5" cy="129.5" r="129.5" />
                  </g>
                  <defs>
                    <filter
                      id="filter0_f_1_105"
                      x="0"
                      y="-214"
                      width="687"
                      height="687"
                      filterUnits="userSpaceOnUse"
                      colorInterpolationFilters="sRGB"
                    >
                      <feFlood floodOpacity="0" result="BackgroundImageFix" />
                      <feBlend
                        mode="normal"
                        in="SourceGraphic"
                        in2="BackgroundImageFix"
                        result="shape"
                      />
                      <feGaussianBlur
                        stdDeviation="107"
                        result="effect1_foregroundBlur_1_105"
                      />
                    </filter>
                  </defs>
                </svg>
              </div>
              <span>Upcoming Campaign Event</span>
              <h2>It's Beginning! Buffalo, NY</h2>
              <p>Saturday, June 15th, 2024 | 10:00 AM - 4:00 PM</p>
              <p>
                Join Taisha St. Jean Tard as we kick off our campaign with a day
                of community engagement and excitement!
              </p>
            </div>
          </div>
        </div>
        <div className="election-campaign">
          <div className="row align-items-center">
            <div className="col-12">
              <div className="count-up">
                <div id="clock">
                  <TimeCountDown />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CampaignCountdown;
